export enum SearchLevels {
    recommendedResources = 'recommended',
    partnerResources = 'partner'
}
